import { type SortOption } from '@discover-data/stores/restaurant/model/sort/options';

export default function isValidSort(
  sort: string | null | undefined,
  sortOptions: readonly SortOption[]
): sort is SortOption {
  return sortOptions.some((validSort) => validSort === sort);
}
